import {IRequestCommand} from 'app/services/authentication/connection/iRequestCommand';
import {IContractorEmployeeRequestDto, ErrorDetails} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import {CommandRequestType} from 'app/services/authentication/connection/commandRequestType';
import {ICommandParameters} from 'app/services/authentication/connection/iCommandParameters';
import {ICommandResponse} from 'app/services/authentication/connection/iCommandResponse';

export class DeleteContractorEmployeeCommand extends IRequestCommand<IUpdateContractorEmployeeResponse, ErrorDetails, IUpdateContractorEmployeeCommandRequest> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;

  public setId(employeeid: number) {
    this.urlSections.push('contractorEmployees');
    this.urlSections.push(`${employeeid}`);
    this.composeUrl();
  }
}

export interface IUpdateContractorEmployeeCommandRequest extends IContractorEmployeeRequestDto,  ICommandParameters {

}

export interface IUpdateContractorEmployeeResponse extends ICommandResponse {
  id: number;
}
